import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class NotificationsResolver implements Resolve<{}> {
  constructor(
    private userService: UserService,
  ) { }

  async resolve(): Promise<Observable<any> | Promise<any> | any> {
    await this.userService.refreshUser();

    return { user: this.userService.getUser() };
  }
}
